export function objectKeys<T extends object>(object: T): (keyof T)[] {
	return Object.keys(object) as (keyof T)[];
}

type NonOptional<T> = {
	[P in keyof T]-?: T[P];
};

export function objectEntries<T extends object>(
	object: T,
): [keyof T, NonOptional<T>[keyof T]][] {
	return Object.entries(object) as [keyof T, NonOptional<T>[keyof T]][];
}
